// src/axiosConfig.js

import axios from 'axios';

// Set the default base URL for Axios
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
axios.defaults.withCredentials = true; // Include credentials (cookies) in requests

// Add a request interceptor to include the token in headers
axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

export default axios;